module.exports = __webpack_public_path__ + "img/outcome_04.3ee7c7a4.png";